import { GET_PROJECT_LIST, DELETE_PROJECT } from '../actionTypes';
import { getAxiosInstance } from '../utils/axios-api';
import { getAccessToken } from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';

export const getProjectList = () => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/getProjectList?access_token=${getAccessToken()}`
    );

    dispatch({ type: GET_PROJECT_LIST, payload: response.data || [] });
  } catch (ex) {
    dispatch({ type: GET_PROJECT_LIST, payload: [] });
  }
};

export const deleteProject = (id) => async dispatch => {
  try{
    const response = await getAxiosInstance().get(
      `/deactivateProject?access_token=${getAccessToken()}&projectId=${id}`
    );
    if (response.status === 200) {
      dispatch(getProjectList());
      notify('success', 'Project deleted successfully.');
      return true;
    } else {
      notify('error', 'Failed to delete the project.');
      return false;
    }
  } catch (err) {
  notify('error', 'Something went wrong. Please try again.');
  return false;
  }
}

export const saveProject = (body, projectId) => async dispatch => {
  try {
    if ((projectId || 0) > 0) {
      const response = await getAxiosInstance().put(
        `/saveProject?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        notify('success', 'Project updated successfully');
        return true;
      } else {
        notify('error', 'Project updated failed');
        return false;
      }
    } else {
      const response = await getAxiosInstance().post(
        `/saveProject?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        notify('success', 'Project inserted successfully');
        return true;
      } else {
        notify('error', 'Project inserted failed');
        return false;
      }
    }
  } catch (ex) {
    notify('error', 'Something went wrong. Please try again');
    return false;
  }
};
